import React from 'react'
import { cn, Slider } from '@amusnet/react-ui'
import { BetStepperButton } from '@components'

// Same components everywhere; isPortrait/isLandscape only change CSS sizes.
type UltraPlaySliderRowProps = {
    isLandscape?: boolean
    isPortrait?: boolean
    label: string
    amount: string
    currency?: string
    currentIndex: number
    maxIndex: number
    onDecrement: () => void
    onIncrement: () => void
    onIndexChange: (index: number) => void
    canDecrement: boolean
    canIncrement: boolean
}

const UltraPlaySliderRow: React.FC<UltraPlaySliderRowProps> = ({
    isLandscape,
    isPortrait,
    label,
    amount,
    currency,
    currentIndex,
    maxIndex,
    onDecrement,
    onIncrement,
    onIndexChange,
    canDecrement,
    canIncrement,
}) => (
    <div className={cn('flex flex-col', isLandscape && 'mb-3')}>
        <div
            className={cn(
                'flex',
                isPortrait ? 'flex-col items-center' : 'flex-row justify-center items-baseline gap-2'
            )}
        >
            <span className="font-bold text-center text-[24px] text-ultra-label tracking-[0.01em]">{label}</span>
            <div className={cn('flex items-baseline justify-center gap-[6px]', isPortrait && 'mb-[8px]')}>
                <span className={cn('font-bold text-white text-[30px] leading-[36px]')}>{amount}</span>
                {currency && <span className={cn('font-bold text-white text-[20px] leading-[24px]')}>{currency}</span>}
            </div>
        </div>
        <div className={cn('flex items-center gap-3', isLandscape && 'mt-[5px]')}>
            <BetStepperButton
                type="minus"
                disabled={!canDecrement}
                onClick={onDecrement}
                className={cn('flex-shrink-0 w-[58px] h-[58px]')}
            />
            <div className="flex-1">
                <Slider
                    min={0}
                    max={maxIndex}
                    value={currentIndex}
                    onChange={(val) => onIndexChange(Math.round(val))}
                    showMinMaxValues={false}
                    handleClassName={'w-[64px] h-[64px]'}
                />
            </div>
            <BetStepperButton
                type="plus"
                disabled={!canIncrement}
                onClick={onIncrement}
                className={cn('flex-shrink-0 w-[58px] h-[58px]')}
            />
        </div>
    </div>
)

export default UltraPlaySliderRow
